"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CJField = exports.CJFieldContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var CJFormContext_1 = require("../CJFormContext");
var CJFormTab_1 = require("../CJFormTab");
var react_2 = __importDefault(require("react"));
var useRandomGuid_1 = require("../../../hooks/useRandomGuid");
var CJFormSection_1 = require("../CJFormSection");
var Field_1 = require("../../../components/Field");
var util_1 = require("../util");
exports.CJFieldContext = react_2.default.createContext({});
var CJField = function (_a) {
  var htmlFor = _a.htmlFor,
    name = _a.name,
    className = _a.className,
    label = _a.label,
    _b = _a.help,
    help = _b === void 0 ? "" : _b,
    optional = _a.optional,
    _c = _a.optionalLabel,
    optionalLabel = _c === void 0 ? "Optional" : _c,
    fullWidth = _a.fullWidth,
    labelTooltip = _a.labelTooltip,
    _d = _a.tooltipProps,
    tooltipProps = _d === void 0 ? {} : _d,
    children = _a.children,
    secondaryHelp = _a.secondaryHelp,
    required = _a.required,
    restProps = __rest(_a, ["htmlFor", "name", "className", "label", "help", "optional", "optionalLabel", "fullWidth", "labelTooltip", "tooltipProps", "children", "secondaryHelp", "required"]);
  var _e = (0, react_1.useContext)(CJFormContext_1.CJFormContext),
    formState = _e.formState,
    watch = _e.watch,
    trigger = _e.trigger;
  var _f = (0, react_1.useContext)(CJFormTab_1.CJFormTabContext),
    addName = _f.addName,
    removeName = _f.removeName;
  var _g = (0, react_1.useContext)(CJFormSection_1.CJFormSectionContext),
    addSectionName = _g.addName,
    removeSectionName = _g.removeName;
  var _h = __read((0, useRandomGuid_1.useRandomGuid)(), 1),
    guid = _h[0];
  (0, react_1.useEffect)(function () {
    addName(name);
    addSectionName(name);
    return function () {
      removeSectionName(name);
      removeName(name);
    };
  }, []);
  (0, react_1.useEffect)(function () {
    var err = formState.errors[name !== null && name !== void 0 ? name : ""];
    if (!required && (err === null || err === void 0 ? void 0 : err.type) === "required") {
      trigger(name);
    }
  }, [required]);
  var _error = (0, util_1.useFieldError)(name !== null && name !== void 0 ? name : "");
  var _help = typeof help === "function" ? help(watch(name !== null && name !== void 0 ? name : "")) : help;
  var _secondaryHelp = typeof secondaryHelp === "function" ? secondaryHelp(watch(name !== null && name !== void 0 ? name : "")) : secondaryHelp;
  return (0, jsx_runtime_1.jsx)(Field_1.Field, __assign({}, restProps, {
    error: _error,
    help: _help,
    secondaryHelp: _secondaryHelp,
    label: label,
    labelTooltip: labelTooltip,
    tooltipProps: tooltipProps,
    labelFor: htmlFor !== null && htmlFor !== void 0 ? htmlFor : guid,
    required: required,
    optional: optional,
    optionalLabel: optionalLabel,
    className: (0, classnames_1.default)("vsx-cjform-cjfield", fullWidth && "vsx-cjform-fullwidth", className)
  }, {
    children: (0, jsx_runtime_1.jsx)(exports.CJFieldContext.Provider, __assign({
      value: {
        fieldName: name,
        fieldGuid: guid
      }
    }, {
      children: children
    }))
  }));
};
exports.CJField = CJField;
var errorMessages = {
  required: "This field is required"
};